export enum OperationType {
    PAYMENT = 'PAYMENT',
    PAYOUT = 'PAYOUT',
    TOP_UP = 'TOP_UP',
    WITHDRAWAL = 'WITHDRAWAL'
}
